import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';

import { updateStudent, getStudent } from '../actions/studentActions';
import { getBids } from '../actions/bidActions';
import { getAgreements } from '../actions/agreementActions';
import StudentForm from '../components/student/StudentForm';
import { countriesArray } from '../constants/countries';
import Spinner from '../components/common/Spinner';
import { toSelect } from '../utils/helpers';
import '../styles/new-student.scss';

class EditStudentPage extends Component {
  constructor() {
    super();

    this.state = { countries: [] };

    this.editStudent = this.editStudent.bind(this);
  }

  componentWillMount() {
    const { id } = this.props.match.params;
    const {
      getStudent,
      getBids,
      getAgreements,
      student,
      bids,
      agreements
    } = this.props;
    const loadedStudent = !_.isEmpty(student) && student.id == id;
    !loadedStudent && getStudent(id);
    _.isEmpty(bids) && getBids();
    _.isEmpty(agreements) && getAgreements();
  }

  editStudent(student) {
    const { id } = this.props.match.params;
    const { updateStudent } = this.props;
    updateStudent(student, id);
  }

  render() {
    const { bids, agreements, student, loading } = this.props;
    const getInitValues = () => {
      const initialValues = {
        ...student,
        gradeInstanceId: student.currentGradeInstance.id,
        cycleId: student.currentGradeInstance.cycleId
      };
      if (student.category === 'convenio') {
        initialValues.agreementId = student.agreement.id;
      } else if (student.category === 'licitacion') {
        initialValues.bidId = student.bid.id;
      }
      return initialValues;
    };

    return (
      <div id="new-student">
        <h4>EDITAR ALUMNO</h4>
        { !loading && !_.isEmpty(student) &&
          <StudentForm
            initialValues={getInitValues()}
            onSubmit={this.editStudent}
            bids={toSelect(bids)}
            agreements={toSelect(agreements)}
            countries={countriesArray()}
            submitText="Editar Alumno"
          />
        }
        { loading && <Spinner /> }
      </div>
    );
  }
}

const { object, array, bool, func } = PropTypes;

EditStudentPage.propTypes = {
  updateStudent: func.isRequired,
  getStudent: func.isRequired,
  getBids: func.isRequired,
  getAgreements: func.isRequired,
  bids: array.isRequired,
  agreements: array.isRequired,
  loading: bool.isRequired,
  student: object.isRequired,
  match: object.isRequired
};

const mapState = (state) => {
  const getStudent = (state) => {
    let student = state.getIn(['student', 'student']);
    student = student.filter(prop => prop !== null);
    const parents = student.get('parents')
      .map(parent => parent.filter(prop => prop !== null));
    student = student.set('parents', parents);
    return student.toJS();
  };
  return {
    student: getStudent(state),
    bids: state.get('bid').toJS(),
    agreements: state.get('agreement').toJS(),
    loading: state.getIn(['student', 'loading'])
  };
};

const mapDispatch = dispatch => ({
  updateStudent: (student, id) => dispatch(updateStudent(student.toJS(), id)),
  getStudent: id => dispatch(getStudent(id)),
  getBids: () => dispatch(getBids()),
  getAgreements: () => dispatch(getAgreements())
});

export default connect(mapState, mapDispatch)(EditStudentPage);



// WEBPACK FOOTER //
// ./src/containers/EditStudentPage.js